import { Control, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

// local imports
import DateUtil from 'utils/DateUtil'
import { IHealthLocationList } from 'types/HealthType'
import { ILactationRoomFilteredReq } from 'types/LactationType'
import DatePickerIcon from 'components/ui/DatePickerIcon'
import LocationMultiselect from 'components/ui/LocationMultiselect'
import { DatePickerWrapper, FilterButton, ResetButton } from './styled'

interface ILactationRoomFormProps {
  disableResetBtn: boolean
  disableSubmitBtn: boolean
  handleReset: () => void
  control: Control<ILactationRoomFilteredReq>
  locationList: IHealthLocationList[] | undefined
}

export default function LactationRoomFilterForm({
  control,
  locationList,
  handleReset,
  disableResetBtn,
  disableSubmitBtn,
}: ILactationRoomFormProps) {
  const { t } = useTranslation()

  return (
    <>
      {/* Location */}
      <Controller
        name="locationIds"
        control={control}
        render={({ field }) => (
          <LocationMultiselect
            wrapperId="lactationLocationWrapper"
            selectProps={{
              id: 'lactationLocationSelect',
              name: 'locationIds',
              filterPlaceholder: t('most-used-words.search'),
              scrollHeight: '180px',
              maxSelectedLabels: 3,
              panelStyle: { width: '16rem', maxWidth: '400px' },
              placeholder: t('input-texts.choose-location'),
              emptyFilterMessage: t('most-used-words.option-not-found'),
              selectedItemsLabel: `${field.value?.length} ${t('input-texts.location-selected')}`,
              optionLabel: 'name',
              optionValue: 'id',
              options: locationList,
              value: field.value,
              onChange: (e) => field.onChange(e.value),
            }}
          />
        )}
      />

      {/* Reservation Date */}
      <DatePickerWrapper id="reservationDateWrapper">
        <Controller
          name="reservationDate"
          control={control}
          render={({ field }) => (
            <DatePickerIcon
              readOnlyInput={false}
              selectOtherMonths
              showOtherMonths
              disabledDays={[]}
              idName="lactationReservationDate"
              defaultDate={field.value}
              minDate={DateUtil.previousMonth()}
              maxDate={DateUtil.futureMonth()}
              onSelectedDateChange={(e) => field.onChange(e.value as Date)}
              label={t('input-texts.reservation-date')}
              placeholder={t('input-texts.reservation-date')}
            />
          )}
        />
      </DatePickerWrapper>

      {/* Action Buttons */}
      <ResetButton
        id="lactationResetBtn"
        disabled={disableResetBtn}
        type="button"
        onClick={handleReset}
        label={t('most-used-words.reset')}
        className="p-button-outlined"
      />

      <FilterButton
        id="lactationFilterBtn"
        disabled={disableSubmitBtn}
        type="submit"
        label={t('most-used-words.filter')}
      />
    </>
  )
}
